import { DivConst } from 'constants/divConst';
import { getDivLabel } from 'utils/app';

import type { JSX } from 'react';

/**
 * フォームステータス表示コンポーネント
 */
export default function FormStatusBadge(props: {
  formStatusDiv: number | null;
  size?: 'normal' | 'large';
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  const getClassColor = (): string => {
    // 稼働
    if (DivConst.items.formStatus.published.value === props.formStatusDiv) {
      return 'form-status-published';
    }
    // 稼働（予約）
    else if (DivConst.items.formStatus.reserved.value === props.formStatusDiv) {
      return 'form-status-reserved';
    }
    // 未稼働
    return 'form-status-unpublished';
  };

  const getClassSize = (): string => {
    if (props.size === 'large') {
      return 'badge-common-lg ';
    }
    return '';
  };

  const getName = (): string => {
    if (props.formStatusDiv == null) {
      return '';
    }
    return getDivLabel('formStatus', props.formStatusDiv);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <span className={`badge badge-common ${getClassSize()} ${getClassColor()}`}>{getName()}</span>
    </>
  );
}
